export let ServiceConfig = {
  endpoint: window.location.protocol + '//' + window.location.host + '/api',
};



// WEBPACK FOOTER //
// ./src/app/shared/config/service.ts